export const environment = {
    production: false,
    env: 'staging',
    apiUrl: 'https://api.staging.tiwi.h6.run',
    s3BucketName: '',
    whitelistedDomains: ['api.staging.tiwi.h6.run'],
    blacklistedRoutes: [/\/api\/public\/(?!permit\/(?:form\/)?ltr(?:[/?]|$))/],
    recaptcha_site_key: '6LceGeUtAAAAAKKWOawf8Nax9Mz-53T0nUMiHZ1u',
    stripePublishableKey: 'pk_test_xePpOhN0gQErKDgzMeHPuRjB',
    gaMeasurementId: '',
    bugsnagApiKey: '0b5010acd124e464cc32cbdd90244644',
};
